import {Component, Inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatDialogModule, MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {RouterLink} from "@angular/router";
import {ConfirmationDialogComponent} from "../../../shared/confirmation-dialog/confirmation-dialog.component";
import {catchError, EMPTY} from "rxjs";
import {NotificationService} from "../../../shared/data-access/notification.service";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-linked-reports-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    RouterLink
  ],
  templateUrl: './linked-reports-dialog.component.html',
  styleUrl: './linked-reports-dialog.component.scss'
})
export class LinkedReportsDialogComponent {
  displayedColumns = ['id', 'date', 'action'];
  private confirmDeleteDialog: MatDialog;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<LinkedReportsDialogComponent>,
    private confirmDeleteDialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private notification: NotificationService,
    private apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: { reports: any[] }
  ) {
  }

  close(): void {
    this.dialogRef.close();
  }

  deleteReport(reportId: string) {
    const confirmDeleteDialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: "Möchten Sie diese Stillstsandsmeldung wirklich löschen?",
        name: "Stillstandsmeldung löschen",
        actions: ['cancel', 'confirm']
      }
    })
    confirmDeleteDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.apiService.deleteReport(reportId)
          .pipe(
            catchError(error => {
              this.notification.showNotification('Fehler beim Löschen der Stillstandsmeldung', 3000);
              console.error('Error deleting report:', error);
              return EMPTY;
            })
          )
          .subscribe(result => {
            if (result) {
              this.notification.showNotification('Stillstandsmeldung erfolgreich gelöscht', 3000);
              this.data.reports = this.data.reports.filter(report => report.id !== reportId);
            }
          })
      }
    })
  }
}
